/* One-time "free shipping, just for you" hint in the cart: shown once per browser when a cart between data-min and the free-shipping
   threshold sits untouched for data-delay seconds while this element is on screen. The button opens /discount/<code> → checkout. */
class KiidsCartHint extends HTMLElement {
  static KEY = 'kiids-ship-hint';
  static shown = false; // true while the hint is on screen on this page; the drawer re-render recreates the element

  static seen() {
    try { return !!localStorage.getItem(KiidsCartHint.KEY); } catch { return false; }
  }

  connectedCallback() {
    if (KiidsCartHint.seen() && !KiidsCartHint.shown) return;
    this.onActivity = () => this.arm();
    this.onCartUpdated = () => (KiidsCartHint.shown ? this.check() : this.arm());
    ['pointerdown', 'keydown', 'scroll', 'touchstart'].forEach((t) => window.addEventListener(t, this.onActivity, { passive: true }));
    document.addEventListener('cart:updated', this.onCartUpdated);
    KiidsCartHint.shown ? this.check() : this.arm();
  }

  disconnectedCallback() {
    clearTimeout(this.timer);
    ['pointerdown', 'keydown', 'scroll', 'touchstart'].forEach((t) => window.removeEventListener(t, this.onActivity));
    document.removeEventListener('cart:updated', this.onCartUpdated);
  }

  arm() {
    clearTimeout(this.timer);
    if (!this.hidden) return;
    this.timer = setTimeout(() => this.check(), Number(this.dataset.delay) * 1000);
  }

  async check() {
    if (!this.isConnected || (KiidsCartHint.seen() && !KiidsCartHint.shown)) return;
    const drawer = this.closest('cart-drawer');
    const onScreen = KiidsCartHint.shown || (drawer ? drawer.classList.contains('open') : this.parentElement.getClientRects().length > 0);
    if (!onScreen) return this.arm(); // not on screen: wait
    const limit = Number(window.free_shipping_price) * 100;
    const total = (await fetch('/cart.js').then((r) => r.json())).total_price;
    if (!limit || total < Number(this.dataset.min) * 100 || total >= limit) {
      this.hidden = true;
      return KiidsCartHint.shown ? undefined : this.arm();
    }
    this.hidden = false;
    KiidsCartHint.shown = true;
    try { localStorage.setItem(KiidsCartHint.KEY, '1'); } catch {}
    this.querySelector('[data-close]')?.addEventListener('click', () => { this.hidden = true; KiidsCartHint.shown = false; });
  }
}
customElements.define('kiids-cart-hint', KiidsCartHint);
